import React, { useState, useEffect, useContext } from "react";
import { multiFactor, PhoneMultiFactorGenerator, PhoneAuthProvider } from "firebase/auth";
import { auth, db } from "../../../../firebase/firebase";
import { SignupContext } from "../../../../context/SignupContext";
import { Link, useNavigate } from "react-router-dom";
import { setDoc, doc } from "firebase/firestore";
import * as Yup from "yup";
import "./step2.css";
import Button from "../../../../components/Button";
import { createUser } from "../../../../api/accounts/userServices";

const Step2 = () => {
  const navigate = useNavigate();
  const { formData, updateFormData } = useContext(SignupContext);
  const { phoneVerificationId, firstName, lastName, phone, email } = formData;
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({ otp: "" });
  const [isFormValid, setIsFormValid] = useState(false);

  const [otp, setOtp] = useState("");

  const schema = Yup.object().shape({
    otp: Yup.string().required("Verification code required").max(6, "OTP not valid").max(6, "OTP not valid"),
  });

  const verifyOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const cred = PhoneAuthProvider.credential(phoneVerificationId, otp);
      const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
      if (auth.currentUser) {
        await multiFactor(auth.currentUser).enroll(multiFactorAssertion, "Personal Cell");
        // await setDoc(doc(db, COLLECTIONS.USERS, auth.currentUser.uid), { phone }, { merge: true });
        await createUser(auth.currentUser.uid, { phone });
        navigate("../success");
      }
    } catch (error) {
      console.error("Failed to verify the code: ", error);
      alert("The verification code entered is incorrect. Please try again.");
      setErrors({ otp: "Verification code is not valid!" });
      // Optionally, implement retry logic or code resending here
    }
  };

  const onInputEvent = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (event.type === "focus") {
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return;
    }
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  useEffect(() => {
    const validate = async (data: { [key: string]: string | undefined }) => {
      try {
        await schema.validate(data, { abortEarly: true });
        setIsFormValid(true);
        setErrors({});
      } catch (err) {
        setIsFormValid(false);
      }
    };

    validate({ otp });
  }, [otp]);

  return (
    <>
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Enter verification code sent to your phone number.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Sign Up</div>
                </div>
                <div className="flex justify-center w-full px-[30px] mb-[30px]">
                  <div className=" bg-skseparatorgray w-full rounded-full h-[5px]">
                    <div className=" bg-skgreen h-[5px] rounded-full" style={{ width: "75%" }}></div>
                  </div>
                </div>

                <div className="mb-5 px-[30px] flex flex-col space-y-[10px] w-full">
                  <label htmlFor="otp" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Verification Code
                  </label>
                  <div className="overflow-hidden formverificationcodefield">
                    <input
                      onBlur={onInputEvent}
                      onFocus={onInputEvent}
                      className="verificationcodetext"
                      type="text"
                      name="otp"
                      inputMode="numeric"
                      autoComplete="one-time-code"
                      pattern="\d{6}"
                      value={otp}
                      onChange={e => setOtp(e.target.value)}
                      placeholder="Enter Code"
                    />
                  </div>

                  {errors.otp && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.otp}</span>}
                  <span className="block mb-2 text-sm text-gray-400 dark:text-gray-600">Verification code sent to the phone {phone}.</span>
                </div>
                <div className="thickseparator"></div>

                <div className="flex flex-col items-center justify-between w-full px-[30px] py-[20px] md:flex-row-reverse  gap-y-[30px]">
                  <Button
                    to="./password"
                    onClick={verifyOtp}
                    className="w-full md:w-auto md:min-w-[120px] formprimarybutton"
                    isDisabled={!isFormValid}
                  >
                    Continue
                  </Button>
                  <Link to="/" className="w-full md:w-auto md:min-w-[120px] formsecondarybutton">
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step2;
